import React, { useState, useEffect, useContext } from "react";
import {
  makeStyles,
  Paper,
  Grid,
  TextField,
  Button,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Switch,
  FormControlLabel,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Box,
  Tooltip,
  Avatar,
  Chip
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Link as LinkIcon,
  Dashboard as DashboardIcon,
  Assessment as AssessmentIcon,
  Settings as SettingsIcon,
  AccountBalance as AccountBalanceIcon,
  ShoppingCart as ShoppingCartIcon,
  People as PeopleIcon,
  Storage as StorageIcon,
  Cloud as CloudIcon,
  Code as CodeIcon,
  Build as BuildIcon,
  Help as HelpIcon,
  Info as InfoIcon,
  Language as LanguageIcon,
  Visibility as VisibilityIcon,
  Work as WorkIcon,
  School as SchoolIcon,
  Home as HomeIcon,
  Favorite as FavoriteIcon,
  Star as StarIcon,
  Bookmark as BookmarkIcon,
  Description as DescriptionIcon,
  Folder as FolderIcon,
  AccountCircle as AccountCircleIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  Chat as ChatIcon,
  Notifications as NotificationsIcon,
  Search as SearchIcon,
  ExpandMore as ExpandMoreIcon,
  Business as BusinessIcon,
  LocalShipping as LocalShippingIcon,
  LocalAtm as LocalAtmIcon,
  CreditCard as CreditCardIcon,
  Receipt as ReceiptIcon,
  AttachMoney as AttachMoneyIcon,
  TrendingUp as TrendingUpIcon,
  BarChart as BarChartIcon,
  PieChart as PieChartIcon,
  Timeline as TimelineIcon,
  InsertChart as InsertChartIcon,
  ShowChart as ShowChartIcon,
  EventNote as EventNoteIcon,
  Event as EventIcon,
  CalendarToday as CalendarTodayIcon,
  Schedule as ScheduleIcon,
  Alarm as AlarmIcon,
  Timer as TimerIcon,
  Map as MapIcon,
  Place as PlaceIcon,
  LocationOn as LocationOnIcon,
  Navigation as NavigationIcon,
  DirectionsCar as DirectionsCarIcon,
  Flight as FlightIcon,
  LocalHospital as LocalHospitalIcon,
  LocalPharmacy as LocalPharmacyIcon,
  Healing as HealingIcon,
  FitnessCenter as FitnessCenterIcon,
  Restaurant as RestaurantIcon,
  LocalCafe as LocalCafeIcon,
  Fastfood as FastfoodIcon,
  ShoppingBasket as ShoppingBasketIcon,
  Store as StoreIcon,
  Storefront as StorefrontIcon,
  LocalMall as LocalMallIcon,
  CardGiftcard as CardGiftcardIcon,
  Loyalty as LoyaltyIcon,
  LocalOffer as LocalOfferIcon,
  Category as CategoryIcon,
  Assignment as AssignmentIcon,
  AssignmentTurnedIn as AssignmentTurnedInIcon,
  Gavel as GavelIcon,
  Policy as PolicyIcon,
  Security as SecurityIcon,
  Lock as LockIcon,
  VpnKey as VpnKeyIcon,
  VerifiedUser as VerifiedUserIcon,
  Group as GroupIcon,
  PersonAdd as PersonAddIcon,
  ContactMail as ContactMailIcon,
  ContactPhone as ContactPhoneIcon,
  Contacts as ContactsIcon,
  Headset as HeadsetIcon,
  HeadsetMic as HeadsetMicIcon,
  Announcement as AnnouncementIcon,
  Report as ReportIcon,
  Error as ErrorIcon,
  Warning as WarningIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Block as BlockIcon,
  ThumbUp as ThumbUpIcon,
  ThumbDown as ThumbDownIcon,
  Grade as GradeIcon,
  EmojiEvents as EmojiEventsIcon,
  DeveloperMode as DeveloperModeIcon,
  BugReport as BugReportIcon,
  Extension as ExtensionIcon,
  Widgets as WidgetsIcon,
  Apps as AppsIcon,
  ViewModule as ViewModuleIcon,
  ViewList as ViewListIcon,
  ViewQuilt as ViewQuiltIcon,
  TableChart as TableChartIcon,
  Dns as DnsIcon,
  Computer as ComputerIcon,
  Laptop as LaptopIcon,
  PhoneAndroid as PhoneAndroidIcon,
  Tablet as TabletIcon,
  Watch as WatchIcon,
  Tv as TvIcon,
  Mouse as MouseIcon,
  Keyboard as KeyboardIcon,
  Print as PrintIcon,
  Router as RouterIcon,
  Wifi as WifiIcon,
  Bluetooth as BluetoothIcon,
  Cast as CastIcon,
  CloudUpload as CloudUploadIcon,
  CloudDownload as CloudDownloadIcon,
  CloudDone as CloudDoneIcon,
  Backup as BackupIcon,
  Restore as RestoreIcon,
  Save as SaveIcon,
  SaveAlt as SaveAltIcon,
  FileCopy as FileCopyIcon,
  FolderOpen as FolderOpenIcon,
  FolderShared as FolderSharedIcon,
  CreateNewFolder as CreateNewFolderIcon,
  AttachFile as AttachFileIcon,
  Image as ImageIcon,
  PhotoCamera as PhotoCameraIcon,
  Videocam as VideocamIcon,
  Mic as MicIcon,
  MusicNote as MusicNoteIcon,
  Movie as MovieIcon,
  PlayArrow as PlayArrowIcon,
  Pause as PauseIcon,
  Stop as StopIcon,
  SkipNext as SkipNextIcon,
  SkipPrevious as SkipPreviousIcon,
  VolumeUp as VolumeUpIcon,
  WbSunny as WbSunnyIcon,
  NightsStay as NightsStayIcon,
  Brightness4 as Brightness4Icon,
  Palette as PaletteIcon,
  Brush as BrushIcon,
  ColorLens as ColorLensIcon,
  FormatPaint as FormatPaintIcon,
  TextFields as TextFieldsIcon,
  FlashOn as FlashOnIcon,
  Whatshot as WhatshotIcon,
  Eco as EcoIcon,
  Nature as NatureIcon,
  Pets as PetsIcon,
  Public as PublicIcon,
  Explore as ExploreIcon,
  Flag as FlagIcon,
  Memory as MemoryIcon,
  Android as AndroidIcon,
  Apple as AppleIcon,
  Facebook as FacebookIcon,
  Twitter as TwitterIcon,
  Instagram as InstagramIcon,
  LinkedIn as LinkedInIcon,
  YouTube as YouTubeIcon,
  WhatsApp as WhatsAppIcon,
  Telegram as TelegramIcon,
  GitHub as GitHubIcon,
  GetApp as GetAppIcon,
  Publish as PublishIcon,
  OpenInNew as OpenInNewIcon,
  Launch as LaunchIcon,
  ExitToApp as ExitToAppIcon,
  PowerSettingsNew as PowerSettingsNewIcon,
  Refresh as RefreshIcon,
  Sync as SyncIcon,
  MoreVert as MoreVertIcon,
  MoreHoriz as MoreHorizIcon,
  FilterList as FilterListIcon,
  Sort as SortIcon,
  List as ListIcon,
  FormatListBulleted as FormatListBulletedIcon,
  PlaylistAdd as PlaylistAddIcon,
  Queue as QueueIcon,
  History as HistoryIcon,
  Update as UpdateIcon,
  AccessTime as AccessTimeIcon,
  Today as TodayIcon,
  DateRange as DateRangeIcon,
  Brightness1 as Brightness1Icon,
  Brightness2 as Brightness2Icon,
  Brightness3 as Brightness3Icon,
  Brightness5 as Brightness5Icon,
  Brightness6 as Brightness6Icon,
  Brightness7 as Brightness7Icon
} from "@material-ui/icons";
import { toast } from "react-toastify";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";
import ConfirmationModal from "../ConfirmationModal";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  addButton: {
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 650,
  },
  iconCell: {
    width: 50,
  },
  actionsCell: {
    width: 120,
  },
  formField: {
    marginBottom: theme.spacing(2),
  },
  urlField: {
    marginBottom: theme.spacing(2),
  },
  activeSwitch: {
    marginLeft: theme.spacing(1),
  },
  emptyState: {
    textAlign: "center",
    padding: theme.spacing(4),
    color: theme.palette.text.secondary,
  },
  linkIcon: {
    marginRight: theme.spacing(1),
    verticalAlign: "middle",
  },
  // Icon Picker Styles
  iconPickerButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1.5, 2),
    border: `1px solid ${theme.palette.type === 'dark' ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)'}`,
    borderRadius: 4,
    cursor: "pointer",
    backgroundColor: "transparent",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.action.hover,
    },
  },
  iconPickerButtonActive: {
    borderColor: theme.palette.primary.main,
    borderWidth: 2,
  },
  selectedIconPreview: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
  },
  selectedIconAvatar: {
    width: 40,
    height: 40,
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
  },
  iconPickerTitle: {
    marginBottom: theme.spacing(1),
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  iconSearchField: {
    marginBottom: theme.spacing(2),
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
    },
  },
  iconGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(80px, 1fr))",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1),
  },
  noIconsFound: {
    gridColumn: "1 / -1",
    textAlign: "center",
    padding: theme.spacing(4),
    color: theme.palette.text.secondary,
  },
  iconOption: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(1.5),
    borderRadius: 8,
    cursor: "pointer",
    transition: "all 0.2s ease",
    border: "2px solid transparent",
    minHeight: 80,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      transform: "scale(1.05)",
    },
  },
  iconOptionSelected: {
    backgroundColor: theme.palette.primary.light + "30",
    borderColor: theme.palette.primary.main,
    "& $iconOptionIcon": {
      color: theme.palette.primary.main,
    },
  },
  iconOptionIcon: {
    fontSize: 36,
    color: theme.palette.text.secondary,
    marginBottom: 6,
  },
  iconOptionLabel: {
    fontSize: 11,
    textAlign: "center",
    color: theme.palette.text.secondary,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 70,
  },
  tableIconAvatar: {
    width: 32,
    height: 32,
    backgroundColor: theme.palette.primary.main,
    marginRight: theme.spacing(1),
  },
  tableNameCell: {
    display: "flex",
    alignItems: "center",
  },
  iconPickerLabel: {
    marginBottom: theme.spacing(0.5),
    fontSize: 12,
    color: theme.palette.text.secondary,
  },
  userChip: {
    margin: theme.spacing(0.5),
  },
  selectedUsersInfo: {
    marginTop: theme.spacing(1),
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(0.5),
  },
  userTypeSpecificInfo: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5),
  },
}));

// Mapeamento de ícones com componentes - Organizados por categoria
const iconOptions = [
  // Básicos
  { value: "Link", label: "Link", component: LinkIcon },
  { value: "Dashboard", label: "Dashboard", component: DashboardIcon },
  { value: "Home", label: "Home", component: HomeIcon },
  { value: "Settings", label: "Config", component: SettingsIcon },
  { value: "Search", label: "Busca", component: SearchIcon },
  { value: "Language", label: "Web", component: LanguageIcon },
  { value: "Public", label: "Global", component: PublicIcon },
  { value: "OpenInNew", label: "Abrir", component: OpenInNewIcon },
  { value: "Launch", label: "Lançar", component: LaunchIcon },

  // Negócios e Finanças
  { value: "Business", label: "Empresa", component: BusinessIcon },
  { value: "Work", label: "Trabalho", component: WorkIcon },
  { value: "AccountBalance", label: "Banco", component: AccountBalanceIcon },
  { value: "LocalAtm", label: "ATM", component: LocalAtmIcon },
  { value: "AttachMoney", label: "Dinheiro", component: AttachMoneyIcon },
  { value: "CreditCard", label: "Cartão", component: CreditCardIcon },
  { value: "Receipt", label: "Recibo", component: ReceiptIcon },
  { value: "ShoppingCart", label: "Carrinho", component: ShoppingCartIcon },
  { value: "ShoppingBasket", label: "Cesta", component: ShoppingBasketIcon },
  { value: "Store", label: "Loja", component: StoreIcon },
  { value: "Storefront", label: "Vitrine", component: StorefrontIcon },
  { value: "LocalMall", label: "Shopping", component: LocalMallIcon },
  { value: "LocalShipping", label: "Entrega", component: LocalShippingIcon },
  { value: "Category", label: "Categoria", component: CategoryIcon },
  { value: "LocalOffer", label: "Oferta", component: LocalOfferIcon },
  { value: "Loyalty", label: "Fidelidade", component: LoyaltyIcon },
  { value: "CardGiftcard", label: "Presente", component: CardGiftcardIcon },

  // Gráficos e Relatórios
  { value: "Assessment", label: "Relatório", component: AssessmentIcon },
  { value: "BarChart", label: "Barras", component: BarChartIcon },
  { value: "PieChart", label: "Pizza", component: PieChartIcon },
  { value: "Timeline", label: "Timeline", component: TimelineIcon },
  { value: "TrendingUp", label: "Tendência", component: TrendingUpIcon },
  { value: "InsertChart", label: "Gráfico", component: InsertChartIcon },
  { value: "ShowChart", label: "Linha", component: ShowChartIcon },
  { value: "TableChart", label: "Tabela", component: TableChartIcon },

  // Pessoas e Contatos
  { value: "People", label: "Pessoas", component: PeopleIcon },
  { value: "Group", label: "Grupo", component: GroupIcon },
  { value: "AccountCircle", label: "Perfil", component: AccountCircleIcon },
  { value: "PersonAdd", label: "Add User", component: PersonAddIcon },
  { value: "Contacts", label: "Contatos", component: ContactsIcon },
  { value: "ContactMail", label: "Contato", component: ContactMailIcon },
  { value: "ContactPhone", label: "Telefone", component: ContactPhoneIcon },

  // Comunicação
  { value: "Email", label: "Email", component: EmailIcon },
  { value: "Phone", label: "Telefone", component: PhoneIcon },
  { value: "Chat", label: "Chat", component: ChatIcon },
  { value: "Notifications", label: "Alertas", component: NotificationsIcon },
  { value: "Announcement", label: "Anúncio", component: AnnouncementIcon },
  { value: "Headset", label: "Headset", component: HeadsetIcon },
  { value: "HeadsetMic", label: "Atendente", component: HeadsetMicIcon },

  // Documentos e Arquivos
  { value: "Description", label: "Documento", component: DescriptionIcon },
  { value: "Assignment", label: "Tarefa", component: AssignmentIcon },
  { value: "AssignmentTurnedIn", label: "Concluído", component: AssignmentTurnedInIcon },
  { value: "Folder", label: "Pasta", component: FolderIcon },
  { value: "FolderOpen", label: "Abrir", component: FolderOpenIcon },
  { value: "FolderShared", label: "Compartilhado", component: FolderSharedIcon },
  { value: "CreateNewFolder", label: "Nova Pasta", component: CreateNewFolderIcon },
  { value: "FileCopy", label: "Copiar", component: FileCopyIcon },
  { value: "AttachFile", label: "Anexo", component: AttachFileIcon },
  { value: "Save", label: "Salvar", component: SaveIcon },
  { value: "SaveAlt", label: "Salvar Alt", component: SaveAltIcon },
  { value: "GetApp", label: "Download", component: GetAppIcon },
  { value: "Publish", label: "Upload", component: PublishIcon },

  // Agenda e Tempo
  { value: "Event", label: "Evento", component: EventIcon },
  { value: "EventNote", label: "Nota", component: EventNoteIcon },
  { value: "CalendarToday", label: "Calendário", component: CalendarTodayIcon },
  { value: "DateRange", label: "Período", component: DateRangeIcon },
  { value: "Today", label: "Hoje", component: TodayIcon },
  { value: "Schedule", label: "Horário", component: ScheduleIcon },
  { value: "AccessTime", label: "Tempo", component: AccessTimeIcon },
  { value: "Alarm", label: "Alarme", component: AlarmIcon },
  { value: "Timer", label: "Timer", component: TimerIcon },
  { value: "History", label: "Histórico", component: HistoryIcon },
  { value: "Update", label: "Atualizar", component: UpdateIcon },

  // Localização
  { value: "Map", label: "Mapa", component: MapIcon },
  { value: "Place", label: "Local", component: PlaceIcon },
  { value: "LocationOn", label: "Localização", component: LocationOnIcon },
  { value: "Navigation", label: "Navegação", component: NavigationIcon },
  { value: "Explore", label: "Explorar", component: ExploreIcon },
  { value: "Flag", label: "Bandeira", component: FlagIcon },
  { value: "DirectionsCar", label: "Carro", component: DirectionsCarIcon },
  { value: "Flight", label: "Avião", component: FlightIcon },

  // Saúde
  { value: "LocalHospital", label: "Hospital", component: LocalHospitalIcon },
  { value: "LocalPharmacy", label: "Farmácia", component: LocalPharmacyIcon },
  { value: "Healing", label: "Saúde", component: HealingIcon },
  { value: "FitnessCenter", label: "Academia", component: FitnessCenterIcon },

  // Alimentação
  { value: "Restaurant", label: "Restaurante", component: RestaurantIcon },
  { value: "LocalCafe", label: "Café", component: LocalCafeIcon },
  { value: "Fastfood", label: "Fast Food", component: FastfoodIcon },

  // Segurança
  { value: "Security", label: "Segurança", component: SecurityIcon },
  { value: "Lock", label: "Cadeado", component: LockIcon },
  { value: "VpnKey", label: "Chave", component: VpnKeyIcon },
  { value: "VerifiedUser", label: "Verificado", component: VerifiedUserIcon },
  { value: "Policy", label: "Política", component: PolicyIcon },
  { value: "Gavel", label: "Jurídico", component: GavelIcon },

  // Status e Feedback
  { value: "CheckCircle", label: "Sucesso", component: CheckCircleIcon },
  { value: "Cancel", label: "Cancelar", component: CancelIcon },
  { value: "Error", label: "Erro", component: ErrorIcon },
  { value: "Warning", label: "Aviso", component: WarningIcon },
  { value: "Info", label: "Info", component: InfoIcon },
  { value: "Help", label: "Ajuda", component: HelpIcon },
  { value: "Report", label: "Report", component: ReportIcon },
  { value: "Block", label: "Bloquear", component: BlockIcon },
  { value: "ThumbUp", label: "Curtir", component: ThumbUpIcon },
  { value: "ThumbDown", label: "Descurtir", component: ThumbDownIcon },

  // Favoritos e Destaques
  { value: "Favorite", label: "Favorito", component: FavoriteIcon },
  { value: "Star", label: "Estrela", component: StarIcon },
  { value: "Bookmark", label: "Marcador", component: BookmarkIcon },
  { value: "Grade", label: "Nota", component: GradeIcon },
  { value: "EmojiEvents", label: "Troféu", component: EmojiEventsIcon },

  // Tecnologia
  { value: "Code", label: "Código", component: CodeIcon },
  { value: "DeveloperMode", label: "Dev", component: DeveloperModeIcon },
  { value: "BugReport", label: "Bug", component: BugReportIcon },
  { value: "Extension", label: "Plugin", component: ExtensionIcon },
  { value: "Widgets", label: "Widgets", component: WidgetsIcon },
  { value: "Apps", label: "Apps", component: AppsIcon },
  { value: "Memory", label: "Memória", component: MemoryIcon },

  // Dispositivos
  { value: "Computer", label: "PC", component: ComputerIcon },
  { value: "Laptop", label: "Laptop", component: LaptopIcon },
  { value: "PhoneAndroid", label: "Celular", component: PhoneAndroidIcon },
  { value: "Tablet", label: "Tablet", component: TabletIcon },
  { value: "Watch", label: "Relógio", component: WatchIcon },
  { value: "Tv", label: "TV", component: TvIcon },
  { value: "Print", label: "Impressora", component: PrintIcon },
  { value: "Router", label: "Roteador", component: RouterIcon },
  { value: "Wifi", label: "Wifi", component: WifiIcon },
  { value: "Bluetooth", label: "Bluetooth", component: BluetoothIcon },
  { value: "Cast", label: "Cast", component: CastIcon },
  { value: "Mouse", label: "Mouse", component: MouseIcon },
  { value: "Keyboard", label: "Teclado", component: KeyboardIcon },

  // Cloud e Storage
  { value: "Cloud", label: "Cloud", component: CloudIcon },
  { value: "CloudUpload", label: "Upload", component: CloudUploadIcon },
  { value: "CloudDownload", label: "Download", component: CloudDownloadIcon },
  { value: "CloudDone", label: "Pronto", component: CloudDoneIcon },
  { value: "Backup", label: "Backup", component: BackupIcon },
  { value: "Restore", label: "Restaurar", component: RestoreIcon },
  { value: "Storage", label: "Storage", component: StorageIcon },
  { value: "Dns", label: "DNS", component: DnsIcon },
  { value: "Sync", label: "Sync", component: SyncIcon },
  { value: "Refresh", label: "Refresh", component: RefreshIcon },

  // Mídia
  { value: "Image", label: "Imagem", component: ImageIcon },
  { value: "PhotoCamera", label: "Câmera", component: PhotoCameraIcon },
  { value: "Videocam", label: "Vídeo", component: VideocamIcon },
  { value: "Mic", label: "Microfone", component: MicIcon },
  { value: "MusicNote", label: "Música", component: MusicNoteIcon },
  { value: "Movie", label: "Filme", component: MovieIcon },
  { value: "PlayArrow", label: "Play", component: PlayArrowIcon },
  { value: "Pause", label: "Pause", component: PauseIcon },
  { value: "Stop", label: "Stop", component: StopIcon },
  { value: "SkipNext", label: "Próximo", component: SkipNextIcon },
  { value: "SkipPrevious", label: "Anterior", component: SkipPreviousIcon },
  { value: "VolumeUp", label: "Volume", component: VolumeUpIcon },

  // Educação
  { value: "School", label: "Escola", component: SchoolIcon },

  // Design e Visual
  { value: "Palette", label: "Paleta", component: PaletteIcon },
  { value: "Brush", label: "Pincel", component: BrushIcon },
  { value: "ColorLens", label: "Cores", component: ColorLensIcon },
  { value: "FormatPaint", label: "Pintura", component: FormatPaintIcon },
  { value: "TextFields", label: "Texto", component: TextFieldsIcon },
  { value: "Brightness4", label: "Brilho", component: Brightness4Icon },

  // Natureza e Clima
  { value: "WbSunny", label: "Sol", component: WbSunnyIcon },
  { value: "NightsStay", label: "Noite", component: NightsStayIcon },
  { value: "Eco", label: "Eco", component: EcoIcon },
  { value: "Nature", label: "Natureza", component: NatureIcon },
  { value: "Pets", label: "Pets", component: PetsIcon },
  { value: "FlashOn", label: "Flash", component: FlashOnIcon },
  { value: "Whatshot", label: "Quente", component: WhatshotIcon },

  // Ações e Interface
  { value: "Build", label: "Ferramenta", component: BuildIcon },
  { value: "Visibility", label: "Visualizar", component: VisibilityIcon },
  { value: "ExitToApp", label: "Sair", component: ExitToAppIcon },
  { value: "PowerSettingsNew", label: "Power", component: PowerSettingsNewIcon },
  { value: "MoreVert", label: "Mais", component: MoreVertIcon },
  { value: "MoreHoriz", label: "Mais H", component: MoreHorizIcon },
  { value: "FilterList", label: "Filtrar", component: FilterListIcon },
  { value: "Sort", label: "Ordenar", component: SortIcon },
  { value: "List", label: "Lista", component: ListIcon },
  { value: "FormatListBulleted", label: "Bullets", component: FormatListBulletedIcon },
  { value: "PlaylistAdd", label: "Add Lista", component: PlaylistAddIcon },
  { value: "Queue", label: "Fila", component: QueueIcon },
  { value: "ViewModule", label: "Módulos", component: ViewModuleIcon },
  { value: "ViewList", label: "Lista", component: ViewListIcon },
  { value: "ViewQuilt", label: "Quilt", component: ViewQuiltIcon },

  // Redes Sociais
  { value: "Facebook", label: "Facebook", component: FacebookIcon },
  { value: "Twitter", label: "Twitter", component: TwitterIcon },
  { value: "Instagram", label: "Instagram", component: InstagramIcon },
  { value: "LinkedIn", label: "LinkedIn", component: LinkedInIcon },
  { value: "YouTube", label: "YouTube", component: YouTubeIcon },
  { value: "WhatsApp", label: "WhatsApp", component: WhatsAppIcon },
  { value: "Telegram", label: "Telegram", component: TelegramIcon },
  { value: "GitHub", label: "GitHub", component: GitHubIcon },
  { value: "Android", label: "Android", component: AndroidIcon },
  { value: "Apple", label: "Apple", component: AppleIcon },
];

// Componente Icon Picker
const IconPicker = ({ value, onChange, label }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSearchTerm("");
  };

  const handleSelect = (iconValue) => {
    onChange(iconValue);
    handleClose();
  };

  const selectedIcon = iconOptions.find((opt) => opt.value === value) || iconOptions[0];
  const SelectedIconComponent = selectedIcon.component;

  // Filtra ícones baseado no termo de busca
  const filteredIcons = iconOptions.filter((option) => {
    const search = searchTerm.toLowerCase();
    return (
      option.label.toLowerCase().includes(search) ||
      option.value.toLowerCase().includes(search)
    );
  });

  return (
    <div>
      <Typography className={classes.iconPickerLabel}>{label}</Typography>
      <Box
        className={`${classes.iconPickerButton} ${open ? classes.iconPickerButtonActive : ""}`}
        onClick={handleOpen}
      >
        <div className={classes.selectedIconPreview}>
          <Avatar className={classes.selectedIconAvatar}>
            <SelectedIconComponent />
          </Avatar>
          <div>
            <Typography variant="body1" style={{ fontWeight: 500 }}>
              {selectedIcon.label}
            </Typography>
            <Typography variant="caption" color="textSecondary">
              Clique para alterar
            </Typography>
          </div>
        </div>
        <ExpandMoreIcon color="action" />
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: { minHeight: '70vh', maxHeight: '85vh' }
        }}
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" style={{ fontWeight: 600 }}>
              Selecione um ícone
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {filteredIcons.length} ícones disponíveis
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            placeholder="Buscar ícone por nome..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className={classes.iconSearchField}
            InputProps={{
              startAdornment: <SearchIcon color="action" style={{ marginRight: 8 }} />,
            }}
            autoFocus
          />
          <div className={classes.iconGrid}>
            {filteredIcons.length === 0 ? (
              <div className={classes.noIconsFound}>
                <Typography variant="body2">
                  Nenhum ícone encontrado para "{searchTerm}"
                </Typography>
              </div>
            ) : (
              filteredIcons.map((option) => {
                const IconComponent = option.component;
                const isSelected = value === option.value;
                return (
                  <Tooltip key={option.value} title={option.label} arrow>
                    <div
                      className={`${classes.iconOption} ${isSelected ? classes.iconOptionSelected : ""}`}
                      onClick={() => handleSelect(option.value)}
                    >
                      <IconComponent className={classes.iconOptionIcon} />
                      <span className={classes.iconOptionLabel}>{option.label}</span>
                    </div>
                  </Tooltip>
                );
              })
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="default">
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

// Função para obter o componente do ícone pelo nome
const getIconComponent = (iconName) => {
  const icon = iconOptions.find((opt) => opt.value === iconName);
  return icon ? icon.component : LinkIcon;
};

const ExternalLinksManager = () => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);

  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [editingLink, setEditingLink] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [linkToDelete, setLinkToDelete] = useState(null);
  const [saving, setSaving] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    url: "",
    icon: "Link",
    userType: "all",
    openMode: "iframe",
    isActive: true,
    order: 0,
    userIds: []
  });
  // Resultado da checagem do destino: null = ainda nao verificado.
  const [embedCheck, setEmbedCheck] = useState(null);
  const [checkingEmbed, setCheckingEmbed] = useState(false);

  const fetchLinks = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/company-external-links");
      setLinks(data);
    } catch (err) {
      toast.error(i18n.t("externalLinks.toasts.errorLoading"));
    }
    setLoading(false);
  };

  const fetchUsers = async () => {
    try {
      const { data } = await api.get("/users");
      setUsers(data.users || data);
    } catch (err) {
      console.error("Error fetching users:", err);
    }
  };

  useEffect(() => {
    fetchLinks();
    fetchUsers();
  }, []);

  const handleOpenModal = (link = null) => {
    if (link) {
      setEditingLink(link);
      const linkUserIds = link.users ? link.users.map(u => u.id) : [];
      setFormData({
        name: link.name,
        url: link.url,
        icon: link.icon || "Link",
        userType: link.userType || "all",
        openMode: link.openMode || "iframe",
        isActive: link.isActive,
        order: link.order || 0,
        userIds: linkUserIds
      });
      setSelectedUsers(link.users || []);
    } else {
      setEditingLink(null);
      setFormData({
        name: "",
        url: "",
        icon: "Link",
        userType: "all",
        openMode: "iframe",
        isActive: true,
        order: links.length,
        userIds: []
      });
      setSelectedUsers([]);
    }
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setEditingLink(null);
    setFormData({
      name: "",
      url: "",
      icon: "Link",
      userType: "all",
      openMode: "iframe",
      isActive: true,
      order: 0,
      userIds: []
    });
    setSelectedUsers([]);
    setEmbedCheck(null);
  };

  /**
   * Pergunta ao backend se o destino aceita ser aberto dentro do sistema.
   *
   * Quem decide e o servidor do site (X-Frame-Options / CSP frame-ancestors), e
   * a maioria dos atalhos pedidos — Google, Gmail, Drive, Docs, ChatGPT — diz
   * nao. Melhor o admin descobrir aqui, ao cadastrar, do que o usuario descobrir
   * com uma tela em branco.
   */
  const verificarUrl = async (url) => {
    if (!url) return;
    try {
      new URL(url);
    } catch (e) {
      return;
    }
    setCheckingEmbed(true);
    try {
      const { data } = await api.get("/company-external-links/check-url", {
        params: { url }
      });
      setEmbedCheck(data);
      // So sugere; o admin continua livre para escolher.
      if (data && data.embeddable === false) {
        setFormData(prev => ({ ...prev, openMode: "new_tab" }));
      }
    } catch (err) {
      setEmbedCheck(null);
    }
    setCheckingEmbed(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleIconChange = (iconValue) => {
    setFormData((prev) => ({ ...prev, icon: iconValue }));
  };

  const handleSwitchChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: checked }));
  };

  const handleUserChange = (event, newValue) => {
    setSelectedUsers(newValue);
    setFormData((prev) => ({
      ...prev,
      userIds: newValue.map(u => u.id)
    }));
  };

  const handleSubmit = async () => {
    if (!formData.name || !formData.url) {
      toast.error(i18n.t("externalLinks.toasts.requiredFields"));
      return;
    }

    // Validação básica de URL
    try {
      new URL(formData.url);
    } catch {
      toast.error(i18n.t("externalLinks.toasts.invalidUrl"));
      return;
    }

    setSaving(true);
    try {
      if (editingLink) {
        await api.put(`/company-external-links/${editingLink.id}`, formData);
        toast.success(i18n.t("externalLinks.toasts.updated"));
      } else {
        await api.post("/company-external-links", formData);
        toast.success(i18n.t("externalLinks.toasts.created"));
      }
      handleCloseModal();
      fetchLinks();
    } catch (err) {
      toast.error(i18n.t("externalLinks.toasts.errorSaving"));
    }
    setSaving(false);
  };

  const handleDeleteClick = (link) => {
    setLinkToDelete(link);
    setConfirmModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    if (!linkToDelete) return;

    try {
      await api.delete(`/company-external-links/${linkToDelete.id}`);
      toast.success(i18n.t("externalLinks.toasts.deleted"));
      fetchLinks();
    } catch (err) {
      toast.error(i18n.t("externalLinks.toasts.errorDeleting"));
    }
    setConfirmModalOpen(false);
    setLinkToDelete(null);
  };

  const handleToggleActive = async (link) => {
    try {
      await api.put(`/company-external-links/${link.id}`, {
        isActive: !link.isActive
      });
      fetchLinks();
    } catch (err) {
      toast.error(i18n.t("externalLinks.toasts.errorUpdating"));
    }
  };

  const getUserTypeLabel = (userType, linkUsers) => {
    switch (userType) {
      case "admin":
        return i18n.t("externalLinks.userTypes.admin");
      case "user":
        return i18n.t("externalLinks.userTypes.user");
      case "specific":
        const count = linkUsers ? linkUsers.length : 0;
        return `${i18n.t("externalLinks.userTypes.specific")} (${count})`;
      case "all":
      default:
        return i18n.t("externalLinks.userTypes.all");
    }
  };

  return (
    <div className={classes.root}>
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddIcon />}
        onClick={() => handleOpenModal()}
        className={classes.addButton}
      >
        {i18n.t("externalLinks.buttons.add")}
      </Button>

      <Paper className={classes.paper}>
        {loading ? (
          <div style={{ textAlign: "center", padding: 20 }}>
            <CircularProgress />
          </div>
        ) : links.length === 0 ? (
          <div className={classes.emptyState}>
            <LinkIcon style={{ fontSize: 48, marginBottom: 16 }} />
            <Typography variant="h6">
              {i18n.t("externalLinks.noLinks")}
            </Typography>
            <Typography variant="body2">
              {i18n.t("externalLinks.noLinksDescription")}
            </Typography>
          </div>
        ) : (
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>{i18n.t("externalLinks.table.name")}</TableCell>
                <TableCell>{i18n.t("externalLinks.table.url")}</TableCell>
                <TableCell>{i18n.t("externalLinks.table.userType")}</TableCell>
                <TableCell>{i18n.t("externalLinks.table.active")}</TableCell>
                <TableCell className={classes.actionsCell}>
                  {i18n.t("externalLinks.table.actions")}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {links.map((link) => {
                const IconComponent = getIconComponent(link.icon);
                return (
                  <TableRow key={link.id}>
                    <TableCell>
                      <div className={classes.tableNameCell}>
                        <Avatar className={classes.tableIconAvatar} style={{ width: 32, height: 32 }}>
                          <IconComponent style={{ fontSize: 18 }} />
                        </Avatar>
                        {link.name}
                      </div>
                    </TableCell>
                    <TableCell>
                      <Typography noWrap style={{ maxWidth: 300 }}>
                        {link.url}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Tooltip
                        title={
                          link.userType === "specific" && link.users && link.users.length > 0
                            ? link.users.map(u => u.name).join(", ")
                            : ""
                        }
                        arrow
                        placement="top"
                      >
                        <span>{getUserTypeLabel(link.userType, link.users)}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell>
                      <Switch
                        checked={link.isActive}
                        onChange={() => handleToggleActive(link)}
                        color="primary"
                        size="small"
                      />
                    </TableCell>
                    <TableCell className={classes.actionsCell}>
                      <IconButton
                        size="small"
                        onClick={() => handleOpenModal(link)}
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => handleDeleteClick(link)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}
      </Paper>

      {/* Modal de Criação/Edição */}
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {editingLink
            ? i18n.t("externalLinks.modal.editTitle")
            : i18n.t("externalLinks.modal.addTitle")}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label={i18n.t("externalLinks.form.name")}
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                variant="outlined"
                required
                className={classes.formField}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label={i18n.t("externalLinks.form.url")}
                name="url"
                value={formData.url}
                onChange={handleInputChange}
                onBlur={(e) => verificarUrl(e.target.value)}
                variant="outlined"
                required
                placeholder="https://exemplo.com"
                className={classes.urlField}
                helperText={
                  checkingEmbed
                    ? i18n.t("externalLinks.form.checkingEmbed")
                    : embedCheck && embedCheck.embeddable === false
                      ? i18n.t("externalLinks.form.embedBlocked")
                      : i18n.t("externalLinks.form.urlHelper")
                }
              />
            </Grid>
            <Grid item xs={12}>
              <IconPicker
                value={formData.icon}
                onChange={handleIconChange}
                label={i18n.t("externalLinks.form.icon")}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined">
                <InputLabel>{i18n.t("externalLinks.form.userType")}</InputLabel>
                <Select
                  name="userType"
                  value={formData.userType}
                  onChange={handleInputChange}
                  label={i18n.t("externalLinks.form.userType")}
                >
                  <MenuItem value="all">
                    {i18n.t("externalLinks.userTypes.all")}
                  </MenuItem>
                  <MenuItem value="admin">
                    {i18n.t("externalLinks.userTypes.admin")}
                  </MenuItem>
                  <MenuItem value="user">
                    {i18n.t("externalLinks.userTypes.user")}
                  </MenuItem>
                  <MenuItem value="specific">
                    {i18n.t("externalLinks.userTypes.specific")}
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined">
                <InputLabel>{i18n.t("externalLinks.form.openMode")}</InputLabel>
                <Select
                  name="openMode"
                  value={formData.openMode}
                  onChange={handleInputChange}
                  label={i18n.t("externalLinks.form.openMode")}
                >
                  <MenuItem value="iframe">
                    {i18n.t("externalLinks.openModes.iframe")}
                  </MenuItem>
                  <MenuItem value="new_tab">
                    {i18n.t("externalLinks.openModes.newTab")}
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {formData.userType === "specific" && (
              <Grid item xs={12}>
                <Autocomplete
                  multiple
                  options={users}
                  getOptionLabel={(option) => `${option.name} (${option.email})`}
                  getOptionSelected={(option, value) => option.id === value.id}
                  value={selectedUsers}
                  onChange={handleUserChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label={i18n.t("externalLinks.form.selectUsers")}
                      placeholder={i18n.t("externalLinks.form.searchUsers")}
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        key={option.id}
                        label={option.name}
                        {...getTagProps({ index })}
                        className={classes.userChip}
                        size="small"
                      />
                    ))
                  }
                />
                <Typography className={classes.userTypeSpecificInfo}>
                  {i18n.t("externalLinks.form.specificUsersHelp")}
                </Typography>
              </Grid>
            )}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label={i18n.t("externalLinks.form.order")}
                name="order"
                type="number"
                value={formData.order}
                onChange={handleInputChange}
                variant="outlined"
                inputProps={{ min: 0 }}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={formData.isActive}
                    onChange={handleSwitchChange}
                    name="isActive"
                    color="primary"
                  />
                }
                label={i18n.t("externalLinks.form.active")}
                className={classes.activeSwitch}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} disabled={saving}>
            {i18n.t("externalLinks.buttons.cancel")}
          </Button>
          <Button
            onClick={handleSubmit}
            color="primary"
            variant="contained"
            disabled={saving}
          >
            {saving ? (
              <CircularProgress size={24} />
            ) : editingLink ? (
              i18n.t("externalLinks.buttons.save")
            ) : (
              i18n.t("externalLinks.buttons.add")
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de Confirmação de Exclusão */}
      <ConfirmationModal
        title={i18n.t("externalLinks.confirmDelete.title")}
        open={confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        onConfirm={handleDeleteConfirm}
      >
        {i18n.t("externalLinks.confirmDelete.message")}
      </ConfirmationModal>
    </div>
  );
};

export default ExternalLinksManager;
